import { gql } from '@apollo/client';

/**
 * 按账单 ID 查询当前生效的收入侧 Invoice 详情（账单未开具时返回 null）
 */
export const GET_REVENUE_INVOICE_BY_BILL_ID = gql`
  query GetRevenueInvoiceByBillId($billId: ID!) {
    getRevenueInvoiceByBillId(billId: $billId) {
      invoiceId
      invoiceNo
      invoiceAmount
      currency
      dueDate
      status
      pdfPreviewUrl
      pdfDownloadUrl
    }
  }
`;

/**
 * 查询账单下 Invoice 推送记录（按 billId 聚合，客户端分页）
 */
export const GET_INVOICE_SEND_RECORDS = gql`
  query GetInvoiceSendRecords($billId: ID!) {
    getInvoiceSendRecords(billId: $billId) {
      success
      code
      message
      content {
        id
        invoiceNo
        recipientEmail
        senderEmail
        sendStatus
        errorMessage
        attachmentDownloadUrl
        urlExpiredAt
        operatorName
        sentAt
      }
    }
  }
`;
